import type { ReactNode } from "react";

import clsx from "clsx";
import { TextArea as AriaTextArea, FieldError, Label, TextField } from "react-aria-components";
import { useController, useFormContext } from "react-hook-form";

import styles from "./text-area.module.css";

type TextAreaProps = {
	className?: string;
	label?: string;
	maxLength?: number;
	/**
	 * react-hook-form field name
	 */
	name: string;
	placeholder?: string;
};

export function TextArea({
	className,
	label,
	maxLength,
	name,
	placeholder,
}: TextAreaProps): ReactNode {
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, name });
	return (
		<TextField
			className={clsx(styles.wrapper, fieldState.invalid && styles.invalidField)}
			isInvalid={!!fieldState.error}
			validationBehavior="aria"
		>
			<Label className="caption bold">{label}</Label>
			<AriaTextArea
				className={clsx(className, styles.textArea, "body-2")}
				maxLength={maxLength}
				onChange={(e) => {
					return field.onChange(e.target.value);
				}}
				placeholder={placeholder}
				value={field.value as string}
			/>
			<FieldError className={clsx("caption", styles.fieldError)}>
				{fieldState.error?.message}
			</FieldError>
		</TextField>
	);
}
